(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.updateNetSuitePaymentIdsToNullModal',
      UpdateNetSuitePaymentIdsToNullModalController
    );

  UpdateNetSuitePaymentIdsToNullModalController.$inject = [
    '$uibModalInstance',
    'abp.services.finance.debugTools',
  ];

  function UpdateNetSuitePaymentIdsToNullModalController(
    $uibModalInstance, 
    debugToolsSvc
  ) {
    const vm = this;
    
    vm.saving = 0;

    vm.updateNetSuitePaymentIdsToNull = updateNetSuitePaymentIdsToNull;
    vm.cancel = cancel;

    function updateNetSuitePaymentIdsToNull() {
      vm.saving += 1;
      debugToolsSvc
        .updateNetSuitePaymentIdsToNull({
          maxCount: vm.maxCount,
          chunkSize: vm.chunkSize,
          paymentNumber: vm.paymentNumber
        })
        .success(() => {
          abp.notify.success(App.localize('Success'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
